// extracted by mini-css-extract-plugin
export default {"container":"Yca-z","innerContainer":"Zca-z","multipleLines":"_ca-z","heading":"ada-z","content":"bda-z","linkColor":"cda-z"};